module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    attrs: {
      "body-padding-bottom": "111px"
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("尊敬的"), _c('a', [_vm._v(_vm._s(this.$store.state.insured.name))]), _vm._v("先生/女士，您好！感谢您选择了横琴人寿"), _c('a', [_vm._v(_vm._s(this.$store.state.order.name))]), _vm._v("保险产品，"), _vm._v("为保障您的权益，请您详细阅读并确认下列问题：")]), _vm._v(" "), _c('ul', {
    staticClass: "notifies"
  }, [_c('li', [_vm._v("1. 电子保单上所填写的信息是否为您本人填写并正确无误？")]), _vm._v(" "), _c('li', [_vm._v("2. 您是否已阅读并理解《人身保险投保提示书》，投保单及投保时的各项资料?  ")]), _vm._v(" "), _c('li', [_vm._v("3. 您对于合同条款，特别是保险责任、责任免除、保险期间等相关内容是否确认已清楚了解？")]), _vm._v(" "), _c('li', [_vm._v("4. 您是否清楚自您收到电子保险单次日起，享有10天的犹豫期，在犹豫期内您可以无条件解除保险合同。犹豫期后解除保险合同您会有一定的损失，我公司将按照合同约定退还保单的现金价值？")]), _vm._v(" "), _c('li', [_vm._v("5. 您所购买产品的缴费期间是"), _c('a', [_vm._v(_vm._s(this.$store.state.order.paymentPeriod) + "年")]), _vm._v("，缴费频率是"), _c('a', [_vm._v("每年")]), _vm._v("，保险期间为"), _c('a', [_vm._v(_vm._s((this.$store.state.order.insurancePeriod == '20' || this.$store.state.order.insurancePeriod == '30') ? this.$store.state.order.insurancePeriod + '年' : '至' + this.$store.state.order.insurancePeriod + '周岁'))]), _vm._v("，每期缴纳保费"), _c('a', [_vm._v(_vm._s(this.$store.getters.computPaymentByIDNumber) + "元")]), _vm._v("。请问您是否清楚？")]), _vm._v(" "), _c('li', [_vm._v("提示您，请确认您投保时留下的基本身份信息、联系电话、地址准确、完整、有效。您有关信息的真实有效将直接影响您保单权益得到切实保障。如果您的联系方式需要变更，可拨打我公司全国统一客服热线400-69-12345通知我们，对于您不清楚的内容，我司会尽快通过全国客服热线与您联系为您详细讲解，谢谢！")])]), _vm._v(" "), (_vm.needIDCard) ? _c('div', [_c('p', {
    staticClass: "tip"
  }, [_vm._v("根据国家反洗钱法规定，您必须上传投保人身份证正反面")]), _vm._v(" "), _c('VueImgInputer', {
    staticStyle: {
      "display": "block",
      "margin": "0 auto",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": "上传身份证正面照片",
      "imgSrc": _vm.positivePicSrc,
      "theme": "light",
      "accept": "image/*",
      "capture": false
    },
    model: {
      value: (_vm.positivePicValue),
      callback: function($$v) {
        _vm.positivePicValue = $$v
      },
      expression: "positivePicValue"
    }
  }), _vm._v(" "), _c('VueImgInputer', {
    staticStyle: {
      "display": "block",
      "margin": "0 auto"
    },
    attrs: {
      "placeholder": "上传身份证反面照片",
      "imgSrc": _vm.negativePicSrc,
      "theme": "light",
      "accept": "image/*",
      "capture": false
    },
    model: {
      value: (_vm.negativePicValue),
      callback: function($$v) {
        _vm.negativePicValue = $$v
      },
      expression: "negativePicValue"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('span', {
    class: {
      active: _vm.confirmFeedback === true
    },
    on: {
      "click": function($event) {
        _vm.changeFeedback(true)
      }
    }
  }, [_vm._v("是，我已全部确认")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.confirmFeedback === false
    },
    on: {
      "click": function($event) {
        _vm.changeFeedback(false)
      }
    }
  }, [_vm._v("否，我需要电话回访")])]), _vm._v(" "), _c('div', {
    staticClass: "next",
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v("确认提交")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10d4a6ac"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feedback.vue
// module id = 628
// module chunks = 1